import React, { FC } from "react";
import CustomCheckbox from "../CustomCheckbox/CustomCheckbox";
import "./RequiredCheckbox.scss";

const RequiredCheckbox: FC<{
  message: string;
  handleClick: () => void;
  isChecked: boolean;
  isInErrorState: boolean;
  linkMessage?: string;
  secondMessage?: string;
}> = ({
  handleClick,
  message,
  isChecked,
  secondMessage,
  linkMessage,
  isInErrorState,
}) => {
  return (
    <div className="required-checkbox">
      <CustomCheckbox checked={isChecked} onClickMethod={handleClick} />
      <p
        className={
          isInErrorState
            ? "required-checkbox__terms-text-error"
            : "required-checkbox__terms-text"
        }
      >
        {message}
        {linkMessage && (
          <a
            target={"_blank"}
            rel="noreferrer"
            className={
              isInErrorState
                ? "required-checkbox__link-error"
                : "required-checkbox__link"
            }
          >
            {linkMessage}
          </a>
        )}
        {secondMessage}
      </p>
    </div>
  );
};

export default RequiredCheckbox;
